<template>
  <div>
    <v-col class="pa-0">
      <v-card
        class="pa-5"
        v-if="project && project.customer"
        :style="{ border: '1px solid var(--primary-boarder-color)' }"
      >
        <v-row class="d-flex justify-space-between align-center">
          <v-col class="title d-flex align-center">
            <v-row>
              <v-col xs="8" sm="8" md="8" lg="6" xl="9">
                <span class="text-md-h5 text-sm-h6 font-weight-bold">{{
                  project.project_name
                }}</span>
                <v-row class="my-5">
                  <v-col
                    cols="2"
                    xs="6"
                    sm="6"
                    md="4"
                    lg="4"
                    xl="2"
                    class="ma-0 pa-1"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          v-bind="attrs"
                          v-on="on"
                          dark
                          v-if="project.project_type"
                          class="px-5 mx-2"
                        >
                          {{
                            project.project_type
                              ? project.project_type.name
                              : ""
                          }}
                        </v-chip>
                      </template>
                      <span>Project Type</span>
                    </v-tooltip>
                  </v-col>
                  <v-col
                    cols="2"
                    xs="6"
                    sm="6"
                    md="4"
                    lg="4"
                    xl="2"
                    class="ma-0 pa-1"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          v-bind="attrs"
                          v-on="on"
                          dark
                          v-if="project.project_branch"
                          class="px-5 mx-2"
                        >
                          {{
                            project.project_branch
                              ? project.project_branch.name
                              : ""
                          }}
                        </v-chip>
                      </template>
                      <span>Project Branch</span>
                    </v-tooltip>
                  </v-col>

                  <v-col
                    cols="2"
                    xs="6"
                    sm="6"
                    md="4"
                    lg="4"
                    xl="2"
                    class="ma-0 pa-1"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          v-bind="attrs"
                          v-on="on"
                          :color="getStatusColors(project.status).chip"
                          :text-color="getStatusColors(project.status).text"
                          dark
                        >
                          {{ project.status }}
                        </v-chip>
                      </template>
                      <span>Status</span>
                    </v-tooltip>
                    <v-menu v-model="statusMenuOpen" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="status in this.statusOptions"
                          :key="status.id"
                          @click="selectStatus(status.label)"
                        >
                          <v-list-item-content>{{
                            status.label
                          }}</v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="2"
                    xs="6"
                    sm="6"
                    md="4"
                    lg="4"
                    xl="2"
                    class="ma-0 pa-1"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          v-bind="attrs"
                          v-on="on"
                          dark
                          @click="openPriorityMenu"
                        >
                          {{ project.priority }}
                        </v-chip>
                      </template>
                      <span>Priority</span>
                    </v-tooltip>
                    <v-menu v-model="priorityMenuOpen" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="priorities in this.priorityOptions"
                          :key="priorities.id"
                          @click="selectPriority(priorities.label)"
                        >
                          <v-list-item-content>{{
                            priorities.label
                          }}</v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="2"
                    xs="6"
                    sm="6"
                    md="4"
                    lg="4"
                    xl="2"
                    class="ma-0 pa-1"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          v-bind="attrs"
                          v-on="on"
                          color="var(--color-secondary-light-green)"
                          text-color="var(--color-secondary-green)"
                          >{{ formatDate(project.start_date) }}
                        </v-chip>
                      </template>
                      <span>Start Date</span>
                    </v-tooltip>
                  </v-col>
                  <v-col
                    cols="2"
                    xs="6"
                    sm="6"
                    md="4"
                    lg="4"
                    xl="2"
                    class="ma-0 pa-1"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          color="var(--color-secondary-light-red)"
                          text-color="var(--color-secondary-red)"
                          v-bind="attrs"
                          v-on="on"
                          >{{ formatDate(project.due_date) }}
                        </v-chip>
                      </template>
                      <span>Due Date</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                xs="4"
                sm="4"
                md="4"
                lg="6"
                xl="3"
                v-if="hasPermission('project.view_customer')"
              >
                <v-list-item three-line>
                  <v-list-item-avatar>
                    <v-avatar>
                      <img
                        v-if="project.customer.profile_image"
                        :src="project.customer.profile_image"
                      />
                      <img v-else :src="defaultImage" />
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <router-link
                      :to="'/customer/' + project.customer.uuid + '/info'"
                    >
                      <v-list-item-title
                        v-if="project.customer.company_name"
                        v-html="project.customer.company_name"
                        class="font-weight-bold text-black"
                      ></v-list-item-title>
                      <v-list-item-title
                        v-else
                        v-html="project.customer.full_name"
                        class="font-weight-bold text-black"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-if="project.customer.company_name"
                        v-html="project.customer.full_name"
                      ></v-list-item-subtitle>
                    </router-link>
                    <v-list-item-subtitle>Customer</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <p
          class="mb-5  text-md-body-1 font-weight-regular project-description"
          style="height: 100px; overflow-y: scroll;"
        >
          {{ project.project_description }}
        </p>
        <div class="mb-5 d-flex justify-space-between align-center">
          <span class="text-md-body-2">Project Progress:</span>
          <span class="font-weight-medium text-md-body-2"
            >{{ statics.total_completed_tasks }}/{{ statics.total_tasks }}</span
          >
        </div>
        <v-row class="mx-0 mb-5">
          <v-progress-linear
            v-model="statics.project_progress"
            color="#00B3FF"
            height="8"
            rounded
          ></v-progress-linear>
        </v-row>
      </v-card>
    </v-col>
    <v-col class="pa-0  mt-5">
      <ProjectStats :statics="statics" class="pa-0"></ProjectStats>
    </v-col>
  </div>
</template>

<script>
import ProjectStats from "@/components/shared/ProjectStats.vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { getStatusColors } from "@/utility/statusColors.js";

export default {
  components: {
    ProjectStats,
  },
  props: {
    project: Object,
    statics: Object,
  },
  data() {
    return {
      defaultImage: require("@/assets/img/avatar.svg"),
      progress: 0,
      selectedStatus: this.project.status || "",
      selectedPriority: this.project.priority || "",
      statusMenuOpen: false,
      priorityMenuOpen: false,
      statusOptions: [
        { id: 1, label: "IN-PROGRESS" },
        { id: 2, label: "COMPLETED" },
        { id: 3, label: "HOLD" },
        { id: 4, label: "PENDING" },
        { id: 5, label: "PLANNING" },
      ],
      priorityOptions: [
        { id: 1, label: "HIGH" },
        { id: 2, label: "MEDIUM" },
        { id: 3, label: "LOW" },
      ],
    };
  },

  watch: {
    project: function(newProject, oldProject) {
      if (newProject !== oldProject) {
        this.calculateProgress();
      }
    },
  },

  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },

  methods: {
    getCurrentDateTime() {
      const now = new Date();
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      };
      return now.toLocaleDateString("en-US", options);
    },

    calculateProgress() {
      const taskCount = this.project.tasks.length;
      const taskCountCompleted = this.project.tasks.filter(
        (task) => task.status === "COMPLETED"
      ).length;
      this.progress = (taskCountCompleted / taskCount) * 100;
    },
    getStatusColors(status) {
      return getStatusColors(status);
    },
    formatDate(inputDate) {
      const date = new Date(inputDate);

      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();

      function getOrdinalSuffix(number) {
        const suffixes = ["th", "st", "nd", "rd"];
        const v = number % 100;
        return suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];
      }
      const formattedDate = `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
      return formattedDate;
    },

    openStatusMenu() {
      this.statusMenuOpen = !this.statusMenuOpen;
    },
    openPriorityMenu() {
      this.priorityMenuOpen = !this.priorityMenuOpen;
    },
    selectStatus(status) {
      this.selectedStatus = status;
      this.statusMenuOpen = false;
      this.$emit("update-status", status);
    },
    selectPriority(priority) {
      this.selectedPriority = priority;
      this.priorityMenuOpen = false;
      this.$emit("update-priority", priority);
    },
  },
};
</script>
